import { Loading } from '@/setup/elementUI'

// 最少显示300ms
const MIN_LOADING_TIME = 300
let loading = null
const queues = []
let loadingTime = 0
let timer

const useLoading = () => {
  function startLoading(params = { message: '加载中...', unique: 'default' }) {
    clearTimeout(timer)
    const { message, unique } = params
    const _message = message ?? '加载中...'
    loadingTime = Date.now()
    if (queues.length === 0) {
      queues.push(unique)
      loading = Loading.service({
        lock: true,
        text: _message,
        background: 'rgba(255,255,255, 0.5)'
      })
    } else {
      loading && (loading.text = _message)
      queues.push(unique)
    }
  }

  function closeLoading(unique = 'default') {
    const diff = Date.now() - loadingTime
    setTimeout(() => {
      const index = queues.indexOf(unique)
      if (index > -1) {
        queues.splice(index, 1)
      } else {
        return
      }
      if (queues.length === 0) {
        if (diff > MIN_LOADING_TIME) {
          loading?.close()
        } else {
          timer = setTimeout(() => {
            loading?.close()
          }, MIN_LOADING_TIME)
        }
      }
    }, 60)
  }

  return { startLoading, closeLoading, queues }
}

window.useLoading = useLoading

export { useLoading }
